export default [
	{
		path: '/redirect',
		component: () => import('@/layouts/Default'),
		hidden: true,
		children: [{
			path: '/redirect/:path*',
			component: () => import('@/pages/redirect/Index/Pages/index')
		}]
	}
]